export default __webpack_public_path__ + "static/media/division-3.e9bd50b9.png";